import { render } from "./EditSubCategoryDialog.vue?vue&type=template&id=381ec2ed"
import script from "./EditSubCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditSubCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__